module.exports = __webpack_public_path__ + "media/images/icons/eye-2da2abdcefb6db11ea06ebf028846e7f.svg";